import type { ApolloClient } from "@apollo/client";
import type { PassioAuth } from "@notemeal/passio-utils";
import { PassioSearchAuthDocument, PassioSearchAuthQuery } from "../types";

const REFRESH_BUFFER_MS = 60_000;

let cachedAuth: PassioAuth | null = null;
let inFlightAuthRequest: Promise<PassioAuth> | null = null;

export const invalidatePassioSearchAuth = (): void => {
  cachedAuth = null;
};

export const getPassioSearchAuth = async (apolloClient: ApolloClient<object>): Promise<PassioAuth> => {
  const now = Date.now();
  if (cachedAuth && cachedAuth.expiresAtMs > now + REFRESH_BUFFER_MS) {
    return cachedAuth;
  }

  if (!inFlightAuthRequest) {
    inFlightAuthRequest = (async () => {
      const { data } = await apolloClient.query<PassioSearchAuthQuery>({
        query: PassioSearchAuthDocument,
        fetchPolicy: "no-cache",
      });

      const auth = data.passioSearchAuth;
      if (!auth) {
        throw new Error("Branded food search is not configured");
      }

      const resolvedAuth: PassioAuth = {
        accessToken: auth.accessToken,
        customerId: auth.customerId,
        expiresAtMs: new Date(auth.expiresAt).getTime(),
      };
      cachedAuth = resolvedAuth;
      return resolvedAuth;
    })();
  }

  try {
    return await inFlightAuthRequest;
  } finally {
    inFlightAuthRequest = null;
  }
};
